import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import moment from 'moment';

export const CheckWeekendOrHoliday = async (props, time) => {
  const user = props.userSession || props;
  const current = moment(time);

  // Fin de semana (Sábado o Domingo)
  if (current.day() === 0 || current.day() === 6) {
    return true;
  }

  // Festivo en el calendario
  try {
    const calendarId = user.calendario?.[current.format('YYYY')]?.id;
    if (calendarId) {
      const calendarDoc = await getDoc(doc(db, 'calendars', calendarId));
      if (calendarDoc.exists()) {
        const monthDays = calendarDoc.data().data?.[current.format('MMMM')]?.days || [];
        const today = monthDays.find((d) => d.date === current.format('YYYY-MM-DD'));
        if (today && (today.color === '#ffc107' || today.hours === '00:00')) {
          return true;
        }
      }
    }
  } catch (error) {
    console.error('Error al comprobar festivo:', error);
  }

  return false;
};

export default CheckWeekendOrHoliday;
